import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const currentYear = new Date().getFullYear();
  return <footer className="w-full bg-[#1B2A4A] text-[#FDF8F0]/60 py-12 border-t border-[#FDF8F0]/10" data-id="element-24">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-25">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-8 text-sm font-medium" data-id="element-26">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-[#C4704B] transition-colors" data-id="element-27">
            Política de Privacidad
          </button>
          <span className="hidden md:inline text-[#FDF8F0]/20" data-id="element-28">•</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-[#C4704B] transition-colors" data-id="element-29">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-xs" data-id="element-30">
          © {currentYear} Reset Familiar. Todos los derechos reservados.
        </p>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-31">
        <div className="space-y-4 text-sm" data-id="element-32">
          <p data-id="element-33">
            <strong data-id="element-34">Última actualización: {currentYear}</strong>
          </p>
          <p data-id="element-35">
            En Reset Familiar, respetamos su privacidad y estamos comprometidos
            a protegerla mediante el cumplimiento de esta política.
          </p>

          <h4 className="font-bold text-[#1B2A4A] text-lg mt-4" data-id="element-36">
            1. Recopilación de Información
          </h4>
          <p data-id="element-37">
            Recopilamos información que usted nos proporciona directamente
            cuando realiza una compra, como su nombre y dirección de correo
            electrónico. Esta información es necesaria para entregarle el
            producto digital.
          </p>

          <h4 className="font-bold text-[#1B2A4A] text-lg mt-4" data-id="element-38">
            2. Uso de la Información
          </h4>
          <p data-id="element-39">
            Utilizamos su información para procesar su pedido, entregar el
            producto digital y enviarle actualizaciones importantes sobre el
            producto. No compartimos su información personal con terceros,
            excepto cuando es necesario para procesar el pago (procesadores de
            pago seguros).
          </p>

          <h4 className="font-bold text-[#1B2A4A] text-lg mt-4" data-id="element-40">
            3. Seguridad de Datos
          </h4>
          <p data-id="element-41">
            Implementamos medidas de seguridad diseñadas para proteger su
            información personal contra pérdidas accidentales y contra el
            acceso, uso, alteración y divulgación no autorizados.
          </p>

          <h4 className="font-bold text-[#1B2A4A] text-lg mt-4" data-id="element-42">4. Cookies</h4>
          <p data-id="element-43">
            Nuestro sitio web puede utilizar cookies para mejorar su experiencia
            de navegación. Usted puede configurar su navegador para rechazar
            todas o algunas cookies.
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-44">
        <div className="space-y-4 text-sm" data-id="element-45">
          <p data-id="element-46">
            <strong data-id="element-47">Última actualización: {currentYear}</strong>
          </p>
          <p data-id="element-48">
            Por favor, lea estos términos y condiciones cuidadosamente antes de
            utilizar nuestro sitio web y comprar nuestros productos.
          </p>

          <h4 className="font-bold text-[#1B2A4A] text-lg mt-4" data-id="element-49">
            1. Propiedad Intelectual
          </h4>
          <p data-id="element-50">
            El contenido del producto "Reset Familiar 7 Días" (texto, gráficos,
            logotipos, imágenes) es propiedad de Reset Familiar y está protegido
            por leyes de derechos de autor. La compra le otorga una licencia
            personal y no transferible para uso doméstico. Queda prohibida su
            distribución, venta o reproducción.
          </p>

          <h4 className="font-bold text-[#1B2A4A] text-lg mt-4" data-id="element-51">
            2. Política de Reembolsos
          </h4>
          <p data-id="element-52">
            Debido a la naturaleza digital del producto, todas las ventas son
            finales. Sin embargo, si tiene problemas técnicos para acceder al
            material, por favor contáctenos para asistencia.
          </p>

          <h4 className="font-bold text-[#1B2A4A] text-lg mt-4" data-id="element-53">
            3. Descargo de Responsabilidad
          </h4>
          <p data-id="element-54">
            Este producto es una guía educativa y no sustituye el consejo
            médico, psicológico o profesional. Los resultados pueden variar
            según cada familia y la consistencia en la aplicación del método.
          </p>

          <h4 className="font-bold text-[#1B2A4A] text-lg mt-4" data-id="element-55">
            4. Modificaciones
          </h4>
          <p data-id="element-56">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación en el sitio web.
          </p>
        </div>
      </Modal>
    </footer>;
}